/**
 * API エンドポイント
 */
export const endpoint = process.env.REACT_APP_API_ENDPOINT || '/api';
